import React from "react";
import { Box, FormControl, Select, MenuItem, FormHelperText } from "@mui/material";

const DropdownFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  value,
  options,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        width: "100%",
      }}
    >
      <FormControl
        sx={{ width: "100%" }}
        error={Boolean(orderFormFieldTouched && orderFormFieldError)}
      >
        <Select
          required
          id={orderFormFieldKey}
          name={orderFormFieldKey}
          value={value}
          onBlur={handleBlur}
          onChange={handleChange}
        >
          {options.map(({ key, name }) => {
            return (
              <MenuItem key={key} value={key}>
                {name}
              </MenuItem>
            );
          })}
        </Select>
        <FormHelperText>
          {orderFormFieldTouched && orderFormFieldError
            ? orderFormFieldError
            : " "}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default DropdownFormSimple; 